// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { LoginModule } from './app.module';
bootstrapAppModule(LoginModule);
